<script>
import form from '@/mixins/form'
import * as acessotela from '@/api/acessotela'

export default {
  mixins: [form],
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    const info = await this.backend.info()
    this.fields = info.form.fields
  },
  data: () => ({
    backend: acessotela,
    fields: [],
    form: {}
  })
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <app-acessomodulo-select slot="fieldModulo" slot-scope="data" :model="form.modulo" @change="v => form.modulo = v" />
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
